import { ProspectDataFileDto } from './ProspectDataFileDto';

/* eslint-disable @typescript-eslint/naming-convention */
export interface ProspectData {
  AlternatePhoneNumber: string;
  Birthday: Date | null;
  CellPhone: string;
  City: string;
  CompanyID: string | null;
  Contact: string;
  Email: string;
  FirstName: string;
  LastName: string;
  LicenseExpirationDate: Date | null;
  LicenseNumber: string;
  LicenseTypeID: number | null;
  LicenseTypeName: string;
  MiddleName: string;
  Notes: string;
  PhoneNumber: string;
  PhysicalCity: string;
  PhysicalState: string;
  PhysicalStreetAddress: string;
  PhysicalAddress2: string;
  PhysicalZipCode: string;
  ProspectID: string;
  SSN: string;
  State: string;
  StreetAddress: string;
  StreetAddress2: string;
  Suffix: string;
  TWICCardExpiration: Date | null;
  TWICCardNumber: string;
  VPCompanyID: number | null;
  ZipCode: string;
  ApplicationStatus: string;
  IsActive: boolean | null;
  Nickname: string;
  CommunicationPreference: string;
  ClaimedCerts: string;
  bFormerEmployee: boolean | null;
  ClaimedTwic: boolean | null;
  Ranking: number | null;
  Files: ProspectDataFileDto[];
  bContacted: boolean | null;
  LastContacted: Date | null;
  bCheckin: boolean | null;
  LastCheckin: Date | null;
  CheckinNotes: string;
  PersonNotes: string;
  TradeGroupIDs: string[];
  TradeClassIDs: string[];
  AbsorbDepartmentId: string;
  Position: string;
  CompanyName: string;
  bExternalGuest: boolean;
}
